export default __webpack_public_path__ + "assets/3bdd9fc27dde4ebe033b3afc081ccfdc.png";